<script setup lang="ts">
import type { CmsElementZebraCmsExpandableText } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementZebraCmsExpandableText;
}>();

const {Rows, headlineText } = props.content?.config

</script>
<template>
    <section class="py-20 md:py-24 lg:py-[130px]">
      <div class="container max-w-[1070px]">
        <h3 class="mb-5 md:mb-7 lg:mb-10" v-html="headlineText.value"></h3>
        <div class="gap-y-10 md:gap-y-14 lg:gap-y-20 flex flex-wrap">
          <div class="grid md:grid-cols-2 items-center gap-[40px] w-full" v-for="(row, index) in Rows.value">
            <div>
              <figure class="w-full h-[360px]">
                <NuxtImg v-if="row.leftImage" loading="lazy" format="webp" :src="row.leftImage.url" class="img-cover" alt=""></NuxtImg>
                <NuxtImg v-if="row.rightImage" loading="lazy" format="webp" :src="row.rightImage.url" class="img-cover" alt=""></NuxtImg>
              </figure>
            </div>
            <div :class="{'md:-order-1': index%2==0}">
              <div v-html="row.rowText"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>
